import React, { useState } from 'react';
import { PlusIcon, MinusIcon } from 'lucide-react';
import { faqs } from '../data/landing';
export function Faq() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="w-full bg-cream py-16 lg:py-24" data-id="element-65" data-mp="1lazbdaswhbdw">
      <div className="mx-auto max-w-readable px-6" data-id="element-66" data-mp="1l9fsdcfv0m8f">
        <h2 className="font-serif text-3xl font-semibold leading-tight text-ink sm:text-4xl" data-id="element-67" data-mp="1gdqpaz4msn7d">
          Preguntas frecuentes
        </h2>

        <div className="mt-10 divide-y divide-teal/15 border-y border-teal/15" data-id="element-68" data-mp="2dyd8b8wlm6y0">
          {faqs.map((faq, index) => {
          const isOpen = openIndex === index;
          return <div key={faq.question} data-id="element-69" data-mp="240ff06zvtjyj" data-mpi={index}>
                <h3 data-id="element-70" data-mp="1z3owld0luc9y">
                  <button type="button" onClick={() => setOpenIndex(isOpen ? null : index)} aria-expanded={isOpen} aria-controls={`faq-panel-${index}`} className="flex w-full items-center justify-between gap-6 py-6 text-left font-serif text-xl font-semibold text-ink transition-colors duration-150 ease-smooth hover:text-teal focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-teal sm:text-2xl" data-id="element-71" data-mp="1z25gpniv238p">
                    {faq.question}
                    {isOpen ? <MinusIcon className="h-6 w-6 flex-none text-teal" aria-hidden="true" data-id="element-72" data-mp="kh0bqmdc25id" /> : <PlusIcon className="h-6 w-6 flex-none text-teal" aria-hidden="true" data-id="element-73" data-mp="bjq0v24fgidz" />}
                  </button>
                </h3>
                {isOpen && <p id={`faq-panel-${index}`} className="pb-6 font-sans text-xl leading-relaxed text-inkSoft" data-id="element-74" data-mp="3jxq61od7algp">
                    {faq.answer}
                  </p>}
              </div>;
        })}
        </div>
      </div>
    </section>;
}